import React from 'react';
import FactoryLeadTimeDisplay from './FactoryLeadTimeDisplay';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { useSystem } from "src/hooks/system";

const ProductInventoryDisplay = (props) => {
    const { single_product, single_product_inventory, showDashedLine = true, imageShow = true, isFromPDP = false, position = "top center", isFrom = "" } = props;
    const { translation: t } = System;
    const [, { get_quantity_format }] = useSystem();

    return (
        <>
            {!isFromPDP ?
                <div className='d-flex flex-column w-100'>
                    <ul className="list-text availibility-list-text mb-2">
                        {/* {!single_product?.SoftwareDownloadFlag ? <>
                            { */}
                                <>
                                    <li className="text-darkgreen">
                                        <span className="d-flex text-darkgreen w-100">
                                            <b>{t('inStock')} :</b>
                                            <b className='ms-auto'>{get_quantity_format(single_product_inventory?.inventoryQty)}</b>
                                            <i className="fa fa-check-circle ms-1" />
                                        </span>
                                    </li>
                                </>
                            {/* }

                        </>
                            :
                            <>
                                <li className="text-darkgreen">
                                    <span className="d-flex text-darkgreen w-100">
                                        <b>{t('inStockDownloadable')}</b>
                                    </span>
                                </li>
                            </>
                        } */}
                        {showDashedLine && <li>
                            <div className='seprator-dashed'></div>
                        </li>}

                        {(isFrom === Constants.systemModules.CART && System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr, Constants.siteUser.CORE)) && (
                            <div>
                                <div className="border-top-0">
                                    <div className="reserved-inventory-box">

                                        <div className="d-flex align-items-center justify-content-between">{t('currentStock')}
                                            <span className="text-md-end">{get_quantity_format(single_product_inventory?.inventoryQty)}</span>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">{t('reservedForYou')}
                                            <span>{get_quantity_format(single_product_inventory?.inventory)}</span>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">{t('totalAccessibleInventory')}
                                            <span>{get_quantity_format(single_product_inventory?.totalInventory)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <li>
                            <div className='d-flex align-items-center w-100'>
                                <FactoryLeadTimeDisplay
                                    single_product={single_product}
                                    single_product_inventory={single_product_inventory}
                                    imageShow={imageShow}
                                    position={position} />
                            </div>
                        </li>
                    </ul>
                </div>
                :
                <>
                    {/* {!single_product?.SoftwareDownloadFlag ?
                        <>
                            {
                                <> */}
                                    <div>
                                        <div className="me-1 text-darkgreen stock-price-title-text">
                                            {t('inStock')} : {get_quantity_format(single_product_inventory?.inventoryQty)} <i className="fa fa-check-circle" />
                                        </div>
                                    </div>
                                {/* </>
                            }

                        </>
                        :

                        <>
                            <div>
                                <div className="me-1 text-darkgreen stock-price-title-text">
                                    {t('inStockDownloadable')}
                                </div>
                            </div>

                        </>
                    } */}

                </>}
        </>
    )
}

export default ProductInventoryDisplay;